// per-account auto-sync interval. stored as a synced pref holding minutes as a
// string. 0 / empty means off (the default).
export type AutoSyncPreset =
  | 'off'
  | 'hourly'
  | '6h'
  | '12h'
  | 'daily'
  | 'custom';

const PRESET_MINUTES: Record<'hourly' | '6h' | '12h' | 'daily', number> = {
  hourly: 60,
  '6h': 360,
  '12h': 720,
  daily: 1440,
};

// english labels. the UI passes these through t() before display.
export const PRESET_OPTIONS: Array<{ value: AutoSyncPreset; label: string }> = [
  { value: 'off', label: 'Off' },
  { value: 'hourly', label: 'Hourly' },
  { value: '6h', label: 'Every 6 hours' },
  { value: '12h', label: 'Every 12 hours' },
  { value: 'daily', label: 'Daily' },
  { value: 'custom', label: 'Custom' },
];

export function minutesToPreset(
  minutesStr: string | undefined,
): AutoSyncPreset {
  const minutes = parseInt(minutesStr ?? '', 10);
  if (!minutes || minutes <= 0 || Number.isNaN(minutes)) {
    return 'off';
  }
  if (minutes === PRESET_MINUTES.hourly) return 'hourly';
  if (minutes === PRESET_MINUTES['6h']) return '6h';
  if (minutes === PRESET_MINUTES['12h']) return '12h';
  if (minutes === PRESET_MINUTES.daily) return 'daily';
  return 'custom';
}

export function presetToMinutes(
  preset: AutoSyncPreset,
  customMinutes: number,
): number {
  if (preset === 'off') return 0;
  if (preset === 'custom') return customMinutes > 0 ? customMinutes : 0;
  return PRESET_MINUTES[preset];
}
